import { render, staticRenderFns } from "./Milling.vue?vue&type=template&id=265f81b7"
import script from "./Milling.vue?vue&type=script&lang=js"
export * from "./Milling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports